import React, { FC, useState } from 'react';
import { Button } from './Button';


interface DownloadButtonProps {
  file : Blob | Promise<Blob> | string;
  filename? : string;
  label? : string;
}

export const DownloadButton: FC<DownloadButtonProps> = (props) => {
  const downloadFile = async () => {
    if(props.file === null) {
      return;
    }

    let downloadUrl = null;
    if (typeof props.file === 'string') {
      downloadUrl = props.file;
    } else {
      const file: Blob = await Promise.resolve(props.file);
      downloadUrl = URL.createObjectURL(file);
    }

    const dlAnchorElem = document.createElement('a');
    dlAnchorElem.setAttribute('href', String(downloadUrl));
    dlAnchorElem.setAttribute('download', `${props.filename || "test.txt"}`);
    dlAnchorElem.click();
  };

  return <Button onClick={downloadFile}>{props.label || "Download"}</Button>;
};
